<div class="consent-settings-container">
    <div class="settings-header">
        <h2>CONSENT FORM SETTINGS</h2>
        <p class="hint">Personalise the consent forms sent by MedicAI to your patients during onboarding. Signed
            forms will be stored in the patient's file. You also have the option to create procedure related consent
            forms that patients can electronically sign and have recorded in their file. These custom forms
            can be accompanied by supplementary information sheets when sent to patients. MedicAI communicates with
            patients for consent via email. Please ensure patients have provided their correct email addresses for
            effective communication. The provided template consents have been reviewed with expert input; however, you
            are
            responsible for using, editing, or replacing them as appropriate for your practice. By using these template
            consents, you acknowledge full responsibility for their application in line with our <a
                href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>.</p>
    </div>
    <mat-accordion multi="false">
        <mat-expansion-panel [expanded]="true" tutorialExpansionTarget="ONBOARDING_CONSENT_FORM">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    PATIENT ONBOARDING CONSENT FORMS
                    <mat-icon class="expansion-header-icon" (click)="openAddConsentFormDialog($event, true, null)"
                        matTooltip="Add a new consent form" color="primary"
                        tutorialHighlightTarget="ONBOARDING_CONSENT_FORM">add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let consentType of defaultConsentTypes" class="note-type-section">
                <div class="action-heading">
                    <h3 class="m-r-10">{{ consentType.label }}{{consentType.consentType === 'interactive' ? '
                        (Interactive AI)' : ''}}</h3>
                    <button mat-icon-button (click)="openAddConsentFormDialog(null, true,  consentType)"
                        matTooltip="Edit this consent form" color="primary"><mat-icon>edit</mat-icon></button>
                    <button mat-icon-button *ngIf="consentType.canDelete" (click)="deleteConsentForm(consentType.id)"
                        matTooltip="Delete this consent form" color="warn"><mat-icon>delete</mat-icon></button>
                    <button mat-icon-button matTooltip="View fullscreen consent"
                        (click)="viewConsentFullscreen(consentType)">
                        <mat-icon>fullscreen</mat-icon>
                    </button>
                </div>
                <pre [innerHtml]="consentType.preview" class="preserve-line-breaks consent-text"></pre>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="false" tutorialExpansionTarget="PROCEDURE_CONSENT_FORM">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    PROCEDURE RELATED CONSENT FORMS
                    <mat-icon class="expansion-header-icon" (click)="openAddConsentFormDialog($event, false, null)"
                        matTooltip="Add a new consent form" color="primary"
                        tutorialHighlightTarget="PROCEDURE_CONSENT_FORM">add</mat-icon>

                    <mat-icon *ngIf="isSupportUser" class="expansion-header-icon m-l-10"
                        (click)="openImportConsentFormsDialog($event)" matTooltip="Import consent forms from JSON"
                        color="primary">upload</mat-icon>
                    <mat-icon *ngIf="consentTemplates.length > 0" class="expansion-header-icon m-l-10"
                        (click)="openImportTemplatesDialog($event)" matTooltip="Import consent forms from templates"
                        color="primary">cloud_download</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let consentType of customConsentTypes" class="note-type-section">
                <div class="action-heading">
                    <h3 class="m-r-10">{{ consentType.label }}{{consentType.consentType === 'interactive' ? '
                        (Interactive AI)' : ''}}</h3>
                    <button mat-icon-button (click)="openAddConsentFormDialog(null, false, consentType)"
                        matTooltip="Edit this consent form" color="primary"><mat-icon>edit</mat-icon></button>
                    <button mat-icon-button *ngIf="consentType.canDelete" (click)="deleteConsentForm(consentType.id)"
                        matTooltip="Delete this consent form" color="warn"><mat-icon>delete</mat-icon></button>
                    <button mat-icon-button matTooltip="View fullscreen consent"
                        (click)="viewConsentFullscreen(consentType)">
                        <mat-icon>fullscreen</mat-icon>
                    </button>
                </div>
                <pre [innerHtml]="consentType.preview" class="preserve-line-breaks consent-text"></pre>
            </div>
        </mat-expansion-panel>

    </mat-accordion>
    <div class="mobile-spacer"></div>
</div>

<ng-template #importConsentFormsDialog>
    <h1 mat-dialog-title>Import Consent Forms from JSON</h1>
    <div mat-dialog-content class="p-t-10">
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Consent Forms JSON</mat-label>
            <textarea matInput rows="10" placeholder="Paste your Consent Form JSON object or array here"
                [(ngModel)]="importConsentFormsJson" (change)="validateJson()"></textarea>
        </mat-form-field>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="importConsentForms()">Import</button>
    </div>
</ng-template>

<ng-template #importTemplatesDialog>
    <h1 mat-dialog-title>Import Consent Forms from Templates</h1>
    <div mat-dialog-content class="p-t-10">
        <p class="m-b-20">Select one or more consent form templates to import into your group:</p>
        <div *ngIf="consentTemplates.length === 0" class="m-t-10 m-b-10">
            <p>No templates available for your specialty.</p>
        </div>
        <div *ngIf="consentTemplates.length > 0" class="template-list">
            <mat-selection-list #templateList (selectionChange)="onTemplateSelectionChange($event)">
                <mat-list-option *ngFor="let template of consentTemplates" [value]="template.id" checkboxPosition="before">
                    {{ template.label }}
                </mat-list-option>
            </mat-selection-list>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" (click)="importSelectedTemplates()" [disabled]="selectedTemplateIds.length === 0">
            Import Selected ({{ selectedTemplateIds.length }})
        </button>
    </div>
</ng-template>

<ng-template #addConsentFormDialog tutorialFormTarget="addConsentFormDialog">

    <h1 mat-dialog-title>Consent Form Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Consent Type</mat-label>
                <mat-select [(ngModel)]="editingConsentForm.consentType"
                    [disabled]="!editingConsentForm.canDelete || editingConsentForm.sendWithInvite"
                    (selectionChange)="setSelectedConsentType($event)">
                    <mat-option value="standard">Standard</mat-option>
                    <mat-option value="interactive">Interactive (AI)</mat-option>
                </mat-select>
            </mat-form-field>

            <ng-container *ngIf="editingConsentForm.consentType">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Consent Form Name</mat-label>
                    <input matInput [(ngModel)]="editingConsentForm.label" placeholder="Consent Form Name" type="text"
                        required [disabled]="!editingConsentForm.canDelete">
                </mat-form-field>

                <ng-container *ngIf="editingConsentForm.consentType === 'interactive'">

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Procedure Title</mat-label>
                        <input matInput [(ngModel)]="editingConsentForm.procedureTitle" placeholder="Procedure Title"
                            type="text" disabled>
                    </mat-form-field>

                    <!-- <div class="full-width" *ngIf="editingConsentForm.consentType === 'interactive' ">
                        <button mat-button matTooltip="Clear the below fields"
                            (click)="fillDefaultInteractiveDetails(editingConsentForm)" color="warn">Clear
                            Defaults</button>
                    </div> -->

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Condition</mat-label>
                        <textarea matInput [(ngModel)]="editingConsentForm.condition" rows="4" disabled></textarea>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Treatment</mat-label>
                        <textarea matInput [(ngModel)]="editingConsentForm.treatment" rows="4" disabled></textarea>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Risks *</mat-label>
                        <textarea matInput [(ngModel)]="editingConsentForm.generalRisks" rows="4"></textarea>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Highlighted Risks</mat-label>
                        <textarea matInput [(ngModel)]="editingConsentForm.specificRisks" rows="4" disabled></textarea>
                    </mat-form-field>

                </ng-container>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Consent Text</mat-label>
                    <textarea matInput [(ngModel)]="editingConsentForm.text" rows="4" required></textarea>
                </mat-form-field>

                <div class="m-b-10 m-t-10">
                    <mat-slide-toggle [(ngModel)]="editingConsentForm.guardianMayComplete" color="primary" data-test="consent-guardian-may-complete">
                        In the patient app, a parent or guardian may sign it for a 12 to 17 year old</mat-slide-toggle>
                </div>

                <ng-container *ngIf="!editingConsentForm.sendWithInvite">

                    <div class="m-b-10 m-t-10">
                        <mat-slide-toggle [(ngModel)]="editingConsentForm.confirmTransfusion"
                            (change)="onConfirmTransfusionChange($event)" color="primary">Patient To
                            Confirm Blood Transfusion</mat-slide-toggle>
                    </div>

                    <div class="m-b-10 m-t-10">
                        <mat-slide-toggle [(ngModel)]="editingConsentForm.confirmSide"
                            (change)="onConfirmSideChange($event)" color="primary">Patient To
                            Confirm
                            Procedure Side</mat-slide-toggle>
                    </div>

                    <mat-form-field class="full-width m-t-10" appearance="outline"
                        *ngIf="editingConsentForm.confirmSide">
                        <mat-label>Procedure Side Options</mat-label>
                        <mat-chip-grid #sideChipGrid aria-label="Enter procedure side options">
                            <mat-chip-row *ngFor="let option of editingConsentForm.sideOptions"
                                (removed)="removeProcedureSideOption(option)" appTouchEdit [editable]="true"
                                (edited)="editProcedureSideOption(option, $event)" [matTooltip]="option">
                                {{option}}
                                <button matChipRemove matTooltip="Remove option">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                            <input placeholder="New Procedure Side Option..." [matChipInputFor]="sideChipGrid"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                                (matChipInputTokenEnd)="addProcedureSideOption($event)" />
                        </mat-chip-grid>
                        <mat-hint>Double click or tap and hold procedure side options to edit their text</mat-hint>
                    </mat-form-field>

                    <div class="m-b-10 m-t-10">
                        <mat-slide-toggle [(ngModel)]="editingConsentForm.confirmImplant"
                            (change)="onConfirmImplantChange($event)" color="primary">Patient To
                            Confirm
                            Implant</mat-slide-toggle>
                    </div>

                    <mat-form-field class="full-width m-t-10" appearance="outline"
                        *ngIf="editingConsentForm.confirmImplant">
                        <mat-label>Implant Options</mat-label>
                        <mat-chip-grid #implantChipGrid aria-label="Enter implant options">
                            <mat-chip-row *ngFor="let option of editingConsentForm.implantOptions"
                                (removed)="removeImplantOption(option)" appTouchEdit [editable]="true"
                                (edited)="editImplantOption(option, $event)" [matTooltip]="option">
                                {{option}}
                                <button matChipRemove matTooltip="Remove option">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                            <input placeholder="New Implant Option..." [matChipInputFor]="implantChipGrid"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                                (matChipInputTokenEnd)="addImplantOption($event)" />
                        </mat-chip-grid>
                        <mat-hint>Double click or tap and hold implant options to edit their text</mat-hint>
                    </mat-form-field>

                </ng-container>


                <!-- <ng-container *ngIf="editingConsentForm.canDelete"> -->
                <mat-form-field class="full-width m-t-10" appearance="outline">
                    <mat-label>Optional Consent</mat-label>
                    <mat-chip-grid #chipGrid aria-label="Enter consent items">
                        <mat-chip-row *ngFor="let consent of editingConsentForm.conditionalConsent"
                            (removed)="removeConditionalConsent(consent)" appTouchEdit [editable]="true"
                            (edited)="editConditionalConsent(consent, $event)" [matTooltip]="consent">
                            {{consent}}
                            <button matChipRemove matTooltip="Remove consent item">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        <input placeholder="New Consent Item..." [matChipInputFor]="chipGrid"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addConditionalConsent($event)" />
                    </mat-chip-grid>
                    <mat-hint>Double click or tap and hold consent items to edit their text</mat-hint>
                </mat-form-field>


                <mat-form-field class="full-width m-t-10" appearance="outline">
                    <mat-label>Required Consent</mat-label>
                    <mat-chip-grid #requiredChipGrid aria-label="Enter consent items">
                        <mat-chip-row *ngFor="let consent of editingConsentForm.additionalRequiredConsent"
                            (removed)="removeRequiredConsent(consent)" appTouchEdit [editable]="true"
                            (edited)="editRequiredConsent(consent, $event)" [matTooltip]="consent">
                            {{consent}}
                            <button matChipRemove matTooltip="Remove consent item">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        <input placeholder="New Consent Item..." [matChipInputFor]="requiredChipGrid"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addRequiredConsent($event)" />
                    </mat-chip-grid>
                    <mat-hint>Double click or tap and hold consent items to edit their text</mat-hint>
                </mat-form-field>


                <app-file-upload [fileObjects]="[]" [allowMultiple]="true" [allowedFileTypes]="'application/pdf'"
                    title="Upload Information Sheets" (fileUpload)="onInformationSheetUpload($event)"
                    hintMessage="Upload your PDF information sheets for this consent form" [showGallery]="false"
                    [shouldRefresh]="true" [pasteEnabled]="false">
                </app-file-upload>

                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Current Information Sheets</mat-label>
                    <mat-chip-grid #informationSheetChipGrid>
                        <mat-chip-row *ngFor="let sheet of editingConsentForm.informationSheets" appTouchEdit [editable]="true"
                            (edited)="editInformationSheetName(sheet, $event)">
                            {{sheet.name}}
                            <button matChipRemove (click)="removeInformationSheet(sheet)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [matChipInputFor]="informationSheetChipGrid" disabled />
                    <mat-hint>Double click or tap and hold an information sheet to edit it's name</mat-hint>
                </mat-form-field>


                <div class="row m-t-10">
                    <h3 class="m-b-0 m-t-10">Preview {{editingConsentForm.label || ''}}</h3>
                    <button mat-icon-button matTooltip="View fullscreen consent"
                        (click)="viewConsentFullscreen(editingConsentForm)">
                        <mat-icon>fullscreen</mat-icon>
                    </button>
                </div>

                <pre class="preserve-line-breaks consent-text"
                    [innerHTML]="buildInteractiveConsent(editingConsentForm)"></pre>
            </ng-container>



            <!-- </ng-container> -->
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="saveConsentForm(editingConsentForm)">Save</button>
    </div>

</ng-template>

<ng-template #fullScreenDialog>
    <h1 mat-dialog-title>{{fullScreenConsentForm.consentLabel || fullScreenConsentForm.label}}</h1>
    <div mat-dialog-content>
        <pre [innerHtml]="fullScreenConsentForm.consentText"
            class="preserve-line-breaks consent-text no-height-limit"></pre>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" mat-dialog-close>Close</button>
    </div>

</ng-template>